<template>
    <v-col cols="12" class=" py-0">
        <v-dialog v-model="dialog" persistent max-width="800">
            <v-card :loading="loading">
                <v-card-title :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:20px">{{  i18n["add_new_settings"] }}
                </v-card-title>
                <v-card-text>
                    <v-row class="align-center">
                        <v-col cols="12" md="6" class="text-center py-1" b-t-n>
                            <v-autocomplete :items="countries" v-model="vendorSetting.country_id" :label="i18n['country']"
                                autocomplete="disabled" outlined @click.stop="" :filter="filterObject" hide-details
                                clearable dense :loading="loading" item-value="id"
                                :class="`${arabic ? 'arFont' : 'enFont'}`">
                                <template v-slot:selection="{ attr, on, item, selected }">
                                    <span v-bind="attr" :input-value="selected" v-on="on"
                                        :class="`${arabic ? 'arFont' : 'enFont'}`">
                                        <v-chip x-small>{{ item.name }} | {{ item.id }}</v-chip>
                                    </span>
                                </template>
                                <template v-slot:item="{ item }">
                                    <span :class="`${arabic ? 'arFont' : 'enFont'}`">
                                        {{ item.name }} | {{ item.id }}
                                    </span>
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="6" class="text-center py-1">
                        <AccountAutocomplete
                          :accounts="accounts"
                          :selectedItem="selectedItem"
                          @on-selected="accountChangedHandler"
                          :loading="loading"
                        />
                        </v-col>

                        <v-col cols="12" md="12" :class="`${arabic ? 'arFont' : 'enFont'} py-2`" b-t-n>
                            {{ i18n['settings_according_to_order_status'] }}
                        </v-col>

                        <v-col cols="12" md="4" class="text-center pa-2">
                            <v-text-field
                                @keypress="isNumber"
                                outlined
                                hide-details
                                dense
                                v-model="vendorSetting.per_confirmed"
                                :class="`${arabic ? 'arFont' : 'enFont'}`"
                                label="per_confirmed"
                            >
                            <template v-slot:append>
                                <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon v-on="on">info</v-icon>
                                </template>
                                {{ i18n["call_center_fees_per_confirmed_order"] }}
                            </v-tooltip>
                            </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="4" class="text-center pa-2">
                            <v-text-field @keypress="isNumber" outlined hide-details dense
                                v-model="vendorSetting.per_noAnswer" :class="`${arabic ? 'arFont' : 'enFont'}`"
                                label="Call Center No Answer"
                            >
                            <template v-slot:append>
                                <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon v-on="on">info</v-icon>
                                </template>
                                {{ i18n["call_center_fees_per_no_answer_cancel"] }}
                                </v-tooltip>
                            </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="4" class="text-center pa-2">
                            <v-text-field @keypress="isNumber" outlined hide-details dense
                                v-model="vendorSetting.per_Human" :class="`${arabic ? 'arFont' : 'enFont'}`"
                                label="Call Center Cancel Human"
                            >
                            <template v-slot:append>
                                <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon v-on="on">info</v-icon>
                                </template>
                                {{ i18n["call_center_fees_per_order_canceled_by_customer"] }}
                                </v-tooltip>
                            </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="4" class="text-center pa-2">
                            <v-text-field @keypress="isNumber" outlined hide-details dense
                                v-model="vendorSetting.per_nonHuman" :class="`${arabic ? 'arFont' : 'enFont'}`"
                                label="Call Center Cancel NonHuman"
                            >
                            <template v-slot:append>
                                <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon v-on="on">info</v-icon>
                                </template>
                                {{ i18n["call_center_fees_per_oreder_canceled_because_of_wrong_number"] }}
                                </v-tooltip>
                            </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="4" class="text-center pa-2">
                            <v-text-field @keypress="isNumber" outlined hide-details dense
                                v-model="vendorSetting.per_order" :class="`${arabic ? 'arFont' : 'enFont'}`"
                                label="Call Center Delivered"
                            >
                            <template v-slot:append>
                                <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon v-on="on">info</v-icon>
                                </template>
                                {{  i18n["call_center_fees_per_delivered_order"] }}
                               </v-tooltip>
                            </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="4" class="text-center pa-2">
                            <v-text-field @keypress="isNumber" outlined hide-details dense
                                v-model="vendorSetting.per_fulfillment" :class="`${arabic ? 'arFont' : 'enFont'}`"
                                label="Fulfillment Fees"
                            >
                            <template v-slot:append>
                                <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon v-on="on">info</v-icon>
                                </template>
                                {{  i18n["fees_per_fulfilled_order"] }}
                               </v-tooltip>
                            </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="4" class="text-center pa-2">
                            <v-text-field @keypress="isNumber" outlined hide-details dense
                                v-model="vendorSetting.per_special_shipping" :class="`${arabic ? 'arFont' : 'enFont'}`"
                                label="Shipping Fee Return"
                            >
                            <template v-slot:append>
                                <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon v-on="on">info</v-icon>
                                </template>
                                {{ i18n['delivery_fees_for_undelivered_order'] }}
                                </v-tooltip>
                            </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="4" class="text-center pa-2">
                            <v-text-field @keypress="isNumber" outlined hide-details dense
                            v-model="vendorSetting.per_special_delivered"
                            :class="`${arabic ? 'arFont' : 'enFont'}`" label="Shipping Fee Special Delivered"
                            >
                            <template v-slot:append>
                                <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon v-on="on">info</v-icon>
                                </template>
                                {{ i18n["delivery_fees_for_deliverd_order_in_addition_to_platform_fees"] }}
                                </v-tooltip>
                            </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="4" class="text-center pa-2">
                            <v-text-field @keypress="isNumber" outlined hide-details dense v-model="vendorSetting.tax"
                                :class="`${arabic ? 'arFont' : 'enFont'}`" label="VAT"
                            >
                            <template v-slot:append>
                                <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon v-on="on">info</v-icon>
                                </template>
                                {{ i18n["vat_added_to_collected_amount_of_order"] }}
                                </v-tooltip>
                            </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="4" class="text-center pa-2">
                            <v-text-field  @keypress="isNumber" outlined hide-details dense v-model="vendorSetting.cod_fee"
                                :class="`${arabic ? 'arFont' : 'enFont'}`" label="COD Fee"
                            >
                            <template v-slot:append>
                                <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon v-on="on">info</v-icon>
                                </template>
                                {{  i18n["cod_collection_fees"] }}
                                </v-tooltip>
                            </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="4" class="text-center pa-2">
                            <v-text-field  @keypress="isNumber" outlined hide-details dense v-model="vendorSetting.currency_rate"
                                :class="`${arabic ? 'arFont' : 'enFont'}`" label="Currency Rate"
                            >
                            <template v-slot:append>
                                <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon v-on="on">info</v-icon>
                                </template>
                                {{  i18n["currency_rate"] }}
                                </v-tooltip>
                            </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="text-center pa-2">
                            <v-switch
                                hide-details inset
                                :class="`${arabic?'arFont':'enFont'} mt-0`"
                                label="Shipping Fee Same as Delivered"
                                v-model="vendorSetting.charge_delivery_on_return">
                            >
                            <template v-slot:append>
                                <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon v-on="on">info</v-icon>
                                </template>
                                {{ i18n["selected_if_agreement_on_return_fees_same_as_deliverd_fees"] }}
                                </v-tooltip>
                            </template>
                            </v-switch>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions :class="`${arabic ? 'arFont' : 'enFont'}`">
                    <v-spacer></v-spacer>
                    <v-btn color="error" text :loading="loading" :class="`${arabic ? 'arFont' : 'enFont'}`"
                        @click="closeDialog">
                        {{ i18n["close"] }}
                    </v-btn>
                    <v-btn v-if="!vendorSetting.id" color="success" :loading="loading" :class="`${arabic ? 'arFont' : 'enFont'}`"
                        @click="saveResourceHandler">
                        <v-icon right size="15">
                            save
                        </v-icon>
                        {{ i18n["add_settings"] }}
                    </v-btn>
                    <v-btn v-if="vendorSetting.id" color="success" :loading="loading" :class="`${arabic ? 'arFont' : 'enFont'}`"
                        @click="updateResourceHandler">
                        <v-icon right size="15">
                            save
                        </v-icon>
                        {{ i18n["update"] }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-col>
</template>

<script>
import typeMixins from '@/mixings/isType';
import laguageMixins from '@/mixings/language';
import AccountAutocomplete from '@/components/AccountAutocomplete';

export default {
  props: ['vendorSetting', 'countries', 'accounts', 'loading', 'dialog'],

  components: { AccountAutocomplete },

  mixins: [typeMixins, laguageMixins],

  methods: {
    saveResourceHandler() {
      this.$emit('on-save', this.vendorSetting);
    },
    updateResourceHandler() {
      this.$emit('on-update', this.vendorSetting);
    },
    filterObject(item, queryText, itemText) {
      const v = Object.values(item).filter((x) => typeof x === 'string');
      let a = false;
      v.forEach((x) => {
        if (x.toLowerCase().includes(queryText.toLowerCase())) a = true;
      });
      if (itemText && typeof itemText === 'string' && itemText.toLowerCase().includes(queryText
        .toLowerCase())) a = true;
      return a;
    },
    closeDialog() {
      this.$emit('closeDialog');
    },
    accountChangedHandler(accountnfo) {
      this.$emit('selectAccount', accountnfo);
    },
  },

  computed: {
    language() {
        return this.$store.state.language
    },
    globalLoading() {
        return this.$store.state.globalLoading
    },
    user() {
        return this.$store.state.user
    },
    i18n() {
        return this.$store.state.i18n[this.$store.state.language]
    },
    arabic() {
        if (this.$store.state.language == 'ar') return true
    },
    selectedItem() {
      const accounts = this.accounts || [];
      return accounts.find((i) => i.id === this.vendorSetting.account_id) || null;
    },
  },
};
</script>

<style>

</style>
